export class AuthCredentials {
    constructor (public username:String, public password:String){

    }
}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/shared/data/auth-credentials.ts